import { Dialog, DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Signal, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { BooksService } from '@app/core';
import { ModalDigitalBooksComponent } from '@app/modules/educational-materials/components/modal-digital-books/modal-digital-books.component';
import { SHARED_MODULES } from '@app/shared';
import { logoByProfile, notNull, permission, safeEmpty, safeEmptyList } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { first, groupBy, map as mapLodash } from 'lodash';
import { map, switchMap, take } from 'rxjs';
import { CardListComponent } from '../card-list/card-list.component';

@Component({
  imports: [...SHARED_MODULES, CardListComponent],
  templateUrl: './modal-books-highlighted.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalBooksHighlightedComponent {
  private readonly _store = inject(Store<AppState>);
  private readonly _booksService = inject(BooksService);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _dialog = inject(Dialog);
  public readonly data = inject(DIALOG_DATA);
  public readonly groupings = signal(undefined);
  protected readonly logo: Signal<string>;

  constructor() {
    this.logo = toSignal(
      this._store.select(AppSelectors.appFeature).pipe(
        takeUntilDestroyed(this._destroyRef),
        map((store) => logoByProfile(store)),
      ),
    );

    this._booksService
      .getHighlighted(this.data.padrao_serie_id)
      .pipe(
        take(1),
        takeUntilDestroyed(this._destroyRef),
        safeEmptyList(),
        map((books) =>
          mapLodash(groupBy(books, 'grouping'), (books) => ({
            description: first<any>(books).grouping,
            books,
          })),
        ),
      )
      .subscribe((data) => this.groupings.set(data));
  }

  public onOpenBook(book: any) {
    this._store
      .select(AppSelectors.ActiveUser)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        notNull(),
        take(1),
        switchMap((activeUser) =>
          this._booksService.getBook(book.slug, permission(activeUser)).pipe(take(1), safeEmpty()),
        ),
      )
      .subscribe((data) =>
        this._dialog.open(ModalDigitalBooksComponent, {
          width: '99vw',
          height: '99vh',
          data,
        }),
      );
  }
}
